module.exports = __webpack_public_path__ + "static/spaceKitchenTablet@x1-2d50e3918130d67c3719d34f8efe70d6.png";